import React, { useMemo } from 'react';
import { WMVirtualizedList, WMVirtualizedListItem } from '@walkme/wm-ui';
import useWindowDimensions from './useWindowDimensions';
const DefaultItemHeight = 40;

export default function VirtualMenuList({ children, maxHeight }: $TSFixMe) {
    const { windowHeight } = useWindowDimensions();

    const childrenOptions = useMemo(() => React.Children.toArray(children), [children]);

    const wrapperHeight = useMemo(() => {
        const adjustedMaxHeight = windowHeight > 750 ? maxHeight : 250;
        return maxHeight < childrenOptions.length * DefaultItemHeight ? adjustedMaxHeight : childrenOptions.length * DefaultItemHeight;
    }, [maxHeight, childrenOptions, windowHeight]);

    return (
        <div style={{ padding: '12px 0' }}>
            {Array.isArray(children) ? (
                <WMVirtualizedList
                    height={`${wrapperHeight + 10}px`}
                    itemHeight={DefaultItemHeight}
                    // @ts-expect-error ts-migrate(2774) FIXME: This condition will always return true since the f... Remove this comment to see the full error message
                    items={children?.map ? children : []}
                    itemFunction={({ item }: WMVirtualizedListItem<$TSFixMe>) => item}
                />
            ) : (
                children
            )}
        </div>
    );
}
